import {SplitText} from "gsap/SplitText";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger, SplitText);
window.addEventListener('load', () => {
const isMobileFirstLoad = window.innerWidth < 768;

if (!isMobileFirstLoad) {

    const tlNewsletter = gsap.timeline(
        {
            scrollTrigger: {
                trigger: '.mksun-block-newsletter'
            }
        },
        '<'
    );

    const titleNewsletter = new SplitText(
        '.mksun-block-newsletter .timeline-text-reveal:not(.timeline-text-reveal--lines)',
        {
            type: 'words'
        }
    );

    const linesNewsletter = new SplitText(
        '.mksun-block-newsletter .timeline-text-reveal--lines',
        {
            type: 'lines',
            linesClass: 'line'
        }
    );

    tlNewsletter.from(
        titleNewsletter.words,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );

    tlNewsletter.from(
        linesNewsletter.lines,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );

    tlNewsletter.from(
        '.mksun-block-newsletter__content__confirm p span',
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );
}});